import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  container: {
    boxSizing: 'border-box',
    width: '100%',
    padding: '0 32px',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    zIndex: 100,
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '274px auto 0',
    color: theme.palette.text.primary,
    '& h1': {
      margin: '6px 0 12px',
    },
  },

  mainContent: {
    width: 328,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    textAlign: 'center',
  },
  description: {
    margin: '0 0 30px',
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.primary.main,
  },
}));
